<template>
  <mdb-container>
    <div v-if="currentGroup">
      <banner-small :group="currentGroup" title="Leave Group"/>
      <mdb-card>
        <mdb-card-body>
          <div v-if="currentGroup.role == 'Admin'">
            You are an admin of {{ currentGroup.name }}. In order to prevent the group from not having
            an administrator, please appoint another person as admin and have them remove you from the group.
          </div>
          <div class="text-left" v-else>
            <h4>Please let {{ currentGroup.name }} know why you're leaving:</h4>
            <mdb-input id="moving-reason" label="Moving Out of Area" name="moving" radioValue="Moving/Relocation"
                       type="radio"
                       v-model="leavingReason"/>
            <mdb-input id="time-reason" label="No Time to Participate" name="time" radioValue="No Time to Participate"
                       type="radio"
                       v-model="leavingReason"/>
            <mdb-input id="personal-reason" label="Personal Reasons" name="personal" radioValue="Personal Reasons"
                       type="radio"
                       v-model="leavingReason"/>
            <mdb-input id="other-reason" label="Other" name="other" radioValue="Other Reason" type="radio"
                       v-model="leavingReason"/>
            <mdb-input id="freeform"
                       placeholder="Please help us understand why you're leaving (optional)."
                       v-if="leavingReason=='Other Reason'"
                       v-model="specifiedReason"/>

            <mdb-btn :disabled="!leavingReason" @click="doLeave" color="danger" icon="door-closed">Leave Now</mdb-btn>
            <mdb-btn @click="homePage" color="success" icon="times-circle">Never Mind</mdb-btn>
          </div>
        </mdb-card-body>
      </mdb-card>
    </div>
  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import bannerSmall from '../group/BannerSmall'
import {mapState} from 'vuex'
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbChipInput,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbRow
} from 'mdbvue';
import Vue from "vue";

export default {
  name: "group-leave",
  components: {
    mdbContainer,
    mdbBtn,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardFooter,
    mdbIcon,
    mdbInput,
    mdbRow,
    mdbCol,
    mdbChipInput,
    bannerSmall,
    mdbBadge
  },
  computed: mapState({
                       currentGroup: state => state.currentGroup,
                       userDetails: state => state.userDetails
                     }),
  data() {
    return {
      details: {forums: [], groupId: null},
      showSummary: true,
      showForum: false,
      currentForum: null,
      leavingReason: null,
      specifiedReason: ""
    }
  },
  watch: {
    leavingReason: function (nv) {
      if (nv == "Other Reason") {
        Vue.nextTick().then(function () {
          let el = document.getElementById("freeform")
          if (el) el.focus()
        });

      }
    }
  },
  mounted() {
    document.title = "Leave Group"
    if (!this.currentGroup) {
      api.groupBasics(this.$route.params.id, "member");
    }
  },
  methods: {
    homePage() {
      this.$router.push("/group/" + this.currentGroup.vanityPath)
    },
    doLeave() {
      //leave action calls old service requiring group id, not path
      let reason = this.leavingReason
      if (reason == "Other Reason") {
        if (this.specifiedReason) reason = this.specifiedReason
        else reason += " (Not Specified)"
      }
      api.post("/member/leave/" + this.currentGroup.id, {leavingReason: reason}).then(
        (results) => {
          this.$notify.success({
                                 message: "Your request to leave " + this.currentGroup.name + " was successful.",
                                 timeOut: 5000
                               })
          let pos = -1
          for (let i = 0; i < this.userDetails.groups.length; i++) {
            if (this.userDetails.groups[i].id == this.currentGroup.id) pos = i
          }
          if (pos > -1) this.userDetails.groups.splice(pos, 1)
          this.$router.push("/")
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
};

</script>
